import { render, staticRenderFns } from "./growth.vue?vue&type=template&id=e133f030&scoped=true"
import script from "./growth.vue?vue&type=script&lang=ts"
export * from "./growth.vue?vue&type=script&lang=ts"
import style0 from "./growth.vue?vue&type=style&index=0&id=e133f030&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e133f030",
  null
  
)

export default component.exports